import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import ProtectedRoute from "./components/guard/ProtectedRoute";
import Routes from "./navigation/Route";
import Login from './pages/auth/LoginPage';//aqui
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/reset-password" component={ResetPassword} />
          {Routes.map((layout, i) => {
            return (
              <ProtectedRoute
                key={i}
                exact={layout.exact}
                path={layout.path}
                component={layout.component}
                name={layout.name}
              />
            );
          })}
        </Switch>
      </Router>
    </>
  );
}

export default App;
